<template lang="">
	<div>
		<p>Acceso otorgado.</p>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	async created() {
		const code = this.$route.query.code;
		await this.saveToken(code);
		this.$router.push({ name: 'timeline' });
	},
	methods: {
		...mapActions({
			saveToken: 'Calendar/saveToken',
		}),
	},
};
</script>
<style lang=""></style>
